import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO, { SITE_URL } from '@/components/SEO';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import LabSection from './components/LabSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@graph': [
    {
      '@type': 'WebSite',
      name: '膳兜兜 foodgogo',
      url: `${SITE_URL}/`,
      description: '膳兜兜foodgogo是依托食品实验室的新锐健康食品品牌，将前沿科技融入日常饮食，提供功能性软糖、冻干滋补品、中式草本能量棒等轻养生食品。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '膳兜兜 foodgogo',
      url: `${SITE_URL}/`,
      description: '膳兜兜foodgogo是依托食品实验室的新锐健康食品品牌，将前沿科技融入日常饮食，提供功能性软糖、冻干滋补品、中式草本能量棒等轻养生食品。',
      brand: {
        '@type': 'Brand',
        name: '膳兜兜 foodgogo',
      },
      slogan: '把实验室装进兜兜，让健康随身go',
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen">
      <SEO
        title="膳兜兜 foodgogo | 把实验室装进兜兜，让健康随身go"
        description="膳兜兜foodgogo是依托食品实验室的新锐健康食品品牌，将前沿科技融入日常饮食，提供功能性软糖、冻干滋补品、中式草本能量棒等轻养生食品。"
        keywords="膳兜兜,foodgogo,健康食品,功能性软糖,冻干滋补,轻养生,膳食,膳养,膳兜兜"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ProductsSection />
        <LabSection />
        <AboutSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}